import { DataObject } from '@shared/models/data-object.model';
import { extractCompanies, PreprocessorCompanyContacts } from './preprocessor-company-contacts.interface';

export class PreprocessorCompanyContactsGeneral implements PreprocessorCompanyContacts {
  processCompanyContacts(record: DataObject): DataObject {
    return {
      ...record,
      company_contact_role_addresses: extractCompanies(record['company_contact_role_addresses']),
      // * Note(Danny): OG data need it to check companies with merged contacts...
      raw_company_contact_role_addresses: record.company_contact_role_addresses,
    };
  }
}
